module.exports = __webpack_public_path__ + "media/images/sandbox/presentation_folder_opt-bc68f3db13bd0ed5354fbbf7e8e07b16.png";